import { getAntiForgeryToken } from '@/utils/getAntiForgeryToken';

export const postAccountAction = async (
  url: string,
  body: Record<string, unknown> = {},
) => {
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      RequestVerificationToken: getAntiForgeryToken(),
    },
    body: JSON.stringify(body),
  });
  return res.json();
};
